import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaTags, FaHeart } from 'react-icons/fa';
import './AdCard.css';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_ENDPOINTS, getImageUrl } from '../config/api';

const AdCard = ({ ad, onFavoriteUpdate }) => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [isFavourite, setIsFavourite] = useState(false);

  // Determine correct image URL
  const imageUrl = ad.images && ad.images.length > 0
    ? ad.images[0].startsWith('http')
      ? ad.images[0]
      : getImageUrl(ad.images[0])
    : 'https://via.placeholder.com/220x220';

  useEffect(() => {
    if (currentUser && ad.favorites) {
      const userId = currentUser.uid;
      setIsFavourite(ad.favorites.includes(userId));
    }
  }, [currentUser, ad.favorites]);

  const handleClick = () => {
    navigate(`/ad/${ad._id}`);
  };

  const handleHeartClick = async (e) => {
    e.stopPropagation(); // Prevent card click
    if (!currentUser) {
      navigate('/login');
      return;
    }

    try {
      const token = await currentUser.getIdToken();
      console.log('Sending request to toggle favorite for ad:', ad._id);
      console.log('User ID:', currentUser.uid);
      
      const response = await axios.post(
        API_ENDPOINTS.ADS.FAVORITE(ad._id),
        {},
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log('Favorite toggle response:', response.data);
      setIsFavourite(response.data.isFavorite);
      
      // Update the parent component if callback is provided
      if (onFavoriteUpdate) {
        onFavoriteUpdate(ad._id, response.data.isFavorite);
      }
      
      toast.success(response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (error) {
      console.error('Error toggling favourite:', error);
      console.error('Error details:', error.response?.data);
      toast.error(error.response?.data?.error || 'Failed to update favorite status', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  return (
    <div className="ad-card" onClick={handleClick}>
      <img src={imageUrl} alt={ad.title} className="ad-card-img" />
      <div className="ad-card-content">
        <h3>{ad.title}</h3>
        <p className="price">₹{ad.price}</p>
        <p className="location">
          <FaMapMarkerAlt /> {`${ad.city}, ${ad.state}`}
        </p>
        <p className="category">
          <FaTags /> {ad.category}
        </p>
        <button 
          className={`favorite-btn ${isFavourite ? 'active' : ''}`}
          onClick={handleHeartClick}
          title={isFavourite ? 'Remove from favorites' : 'Add to favorites'}
        >
          <FaHeart />
        </button>
      </div>
    </div>
  );
};

export default AdCard;
